import { darf, type Recht } from "@gui-creator/gemeinsam";
import { useQueryClient } from "@tanstack/react-query";
import { createContext, useContext } from "react";
import { schluessel, type Konto, type Status } from "../api/abfragen.ts";
import { api } from "../api/klient.ts";

export const KontoKontext = createContext<Konto | null>(null);

export function useKonto(): Konto {
  const k = useContext(KontoKontext);
  if (!k) throw new Error("Kein Konto im Kontext.");
  return k;
}

export function useDarf(recht: Recht): boolean {
  return darf(useKonto().rolle, recht);
}

export function useAbmelden(): () => Promise<void> {
  const qc = useQueryClient();
  return async () => {
    await api("/api/abmelden", { methode: "POST" });
    qc.removeQueries({ predicate: (q) => q.queryKey[0] !== "status" });
    qc.setQueryData<Status>(schluessel.status, { eingerichtet: true, konto: null });
  };
}
